import LoadingFallback from "../loading/loading-fallback"

/* eslint-disable @typescript-eslint/no-unused-vars */
const FullMapFallback = () => {
  return (
    <LoadingFallback className="full-map-fallback skeleton" />
  )
}

export default FullMapFallback